import Radium from '@flipdish/radium';
import * as React from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as Routes from '../../Routes';
import * as Store from '../../Store';
import List from '@material-ui/core/List';
import { PageTitle, SectionHeaderIcon, SectionHeader, Icon, SectionHeaderText } from '../../../ui';
import ListItemConcessionStore from './components/ListItemConcessionStore';
import { MainLayout } from '../MainLayout/MainLayout';

const tinycolor = require('tinycolor2');

interface DispatchProps {}

interface StateProps {
  translate: any;
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
  Menus: Store.MenuData;
  CollectionSummaries: Data.Async<Api.CollectionRestaurantSummary[]>;
}

type Props = DispatchProps & StateProps & Routes.Routes;

interface State {}

class ConcessionList extends React.Component<Props, State> {
  public backLink = (): JSX.Element | null => {
    const { translate, AppDesignScheme, isDark } = this.props;

    const styles = {
      nav: {
        ':hover': {},
        ':active': {}
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      primary: {
        color: AppDesignScheme.Primary
      }
    };

    return (
      <Link to="/collection" data-fd="collection-back">
        <div key="fd-nav" className="fd-nav flex flex-align-center" style={styles.nav as any}>
          <i
            className="arrow_carrot-left tertiary"
            aria-hidden="true"
            style={
              Radium.getState(this.state, 'fd-nav', ':active')
                ? styles.secondaryActive
                : Radium.getState(this.state, 'fd-nav', ':hover')
                ? styles.secondaryHover
                : isDark
                ? styles.primary
                : styles.tertiary
            }
          />
          <p
            className="inline-block clear-margins tertiary bold"
            style={
              Radium.getState(this.state, 'fd-nav', ':active')
                ? styles.secondaryActive
                : Radium.getState(this.state, 'fd-nav', ':hover')
                ? styles.secondaryHover
                : isDark
                ? styles.primary
                : styles.tertiary
            }
          >
            <u>{translate('Back')}</u>
          </p>
        </div>
      </Link>
    );
  };

  public renderStores = (): JSX.Element | null => {
    const { AppDesignScheme, isDark } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      }
    };

    const summary = this.getCollectionSummary();
    if (summary === null) {
      return null;
    }

    const menuUrl = summary.MenuUrl;

    if (!menuUrl) {
      return null;
    }

    const menu = this.props.Menus[menuUrl];

    if (!menu) {
      return null;
    }

    switch (menu.status) {
      case 'pending':
      case 'none':
        return null;
      case 'success':
        const concessionStores = menu.data.ConcessionStores.map((store) => {
          return (
            <ListItemConcessionStore
              key={store.ConcessionStoreId}
              store={store}
              summary={summary}
            />
          );
        });

        return <React.Fragment>{concessionStores}</React.Fragment>;
    }
  };

  private getCollectionSummary(): Api.CollectionRestaurantSummary {
    const { params, CollectionSummaries } = this.props;

    if (CollectionSummaries.status != 'success') {
      return null;
    }
    const versionIndex = CollectionSummaries.data.findIndex(
      (Summary) => Summary.PhysicalRestaurantId === parseInt(params.prid as any)
    );

    if (versionIndex === -1) {
      return null;
    }
    const summary = CollectionSummaries.data[versionIndex];
    return summary;
  }

  public render(): JSX.Element {
    const { translate, AppDesignScheme, isDark } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      subheader: {
        borderColor: AppDesignScheme.Secondary,
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString()
      },
      darkSubheader: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        backgroundColor: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary).darken(10)}`
      }
    };

    var storeName = '';
    const summary = this.getCollectionSummary();
    if (summary != null) {
      storeName = summary.PhysicalRestaurantName;
    }

    return (
      <MainLayout>
        <div className="container">
          <div className="row delivery">
            <div className="col-md-12">
              <div style={{ marginTop: '20px' }} />
              {this.backLink()}
            </div>
            <div className="col-md-8 col-lg-8 col-sm-12">
              <SectionHeader>
                <SectionHeaderIcon>
                  <Icon
                    fontSize="large"
                    aria-hidden
                    color="inherit"
                    className="fa fa-shopping-basket"
                  />
                </SectionHeaderIcon>
                <SectionHeaderText title={storeName} id="skip-to-content" />
              </SectionHeader>
              <List>{this.renderStores()}</List>
            </div>
          </div>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state: Store.State): StateProps => {
  return {
    translate: getTranslate(state.locale),
    AppDesignScheme: state.appDesignScheme,
    isDark: state.flipdish.isDark,
    Menus: state.flipdish.MenuData,
    CollectionSummaries: state.flipdish.CollectionSummaries
  };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(ConcessionList));
